export default __webpack_public_path__ + "static/media/landingBackground1Mobile.22231eef.png";